import { LUDUM_SPORTS } from '@/constants';
import { initialState } from '../helpers/create_session_initial_state';

export const createSession = {
    state: initialState(),

    getters: {
        clubExercises(state) {
            return _.sortBy(state.exercises, 'name');
        },

        sessionDetails(state) {
            return state.details;
        },

        newSessionPreparedData(state, getters, rootState, rootGetters) {
            const data = {};

            // Details

            data.sport = Number(state.details.sessionType);
            data.all_day_event = state.details.all_day_event;

            data.start_date = state.details.startDate;
            if (state.details.endDate.length) {
                data.end_date = state.details.endDate;
            }

            if (state.details.name.length) {
                data.name = state.details.name;
            }

            data.description = state.details.description || '';

            data.planned_distance = state.details.totalDistance;
            data.planned_time = state.details.totalTime;

            // Repeat: We're sending 'null' as a string because of API requirements
            Vue.set(data, 'repeat_frequency_type', 'null');

            if (state.details.repeat.checked) {
                _.forOwn(state.details.repeat, (value, key) => {
                    if (key !== 'checked' && key !== 'editing') {
                        Vue.set(data, key, value);
                    }

                    if (key === 'repeat_frequency_type' && !value) {
                        Vue.set(data, key, 'null');
                    }

                    if (key === 'repeat_end_date') {
                        let repeat_end_date = value ? value : 'null';
                        Vue.set(data, key, repeat_end_date);
                    }
                });
            }

            if (data.sport !== LUDUM_SPORTS.SC) {
                data.intensities = {};
                data.intensity_percentages = {};

                _.each(state.details.intensities, i => {
                    Vue.set(data.intensities, i.id, 0);
                    Vue.set(data.intensity_percentages, i.id, 0);
                    if (i.selected) {
                        Vue.set(data.intensities, i.id, 1);
                        Vue.set(data.intensity_percentages, i.id, i.percentage);
                    }
                });
            }

            data.focuses = {};
            _.each(rootGetters['clubHelper/clubFocuses'], o => {
                Vue.set(data.focuses, o.id, _.find(state.details.focuses, ['id', o.id]) ? 1 : 0);
            });

            _.forOwn(state.details.location, (value, key) => {
                Vue.set(data, key, value);
            });

            if (state.details.tags.length) {
                data.tags = state.details.tags;
            }

            // Attendance & Permissions

            data.athletes = state.attendance.athletes;
            data.coaches = state.attendance.coaches;
            data.athlete_permissions = state.attendance.athlete_permissions;
            data.coach_permissions = state.attendance.coach_permissions;

            // Structures
            data.structures = [];
            data.seat_racing = state.seat_racing;

            if (Number(state.details.sessionType) !== LUDUM_SPORTS.SC && state.work.createPieces) {
                data.structures.push({});
                data.structures[0].sport = data.sport;

                let structure_key = 1;
                _.forOwn(state.work.pieceTypes, (value, key) => {
                    if (value === true) {
                        switch (key) {
                            case 'single':
                                structure_key = 1;
                                break;
                            case 'multiple':
                                structure_key = 2;
                                break;
                            case 'variable':
                                structure_key = 3;
                                break;
                        }
                        data.structures[0].piece_structure = structure_key;
                    }
                });

                data.structures[0].pieces = {};

                if (structure_key !== 3) {
                    // if it's not Variable, take only 1st element
                    state.work.pieces.splice(1);
                }

                if (state.work.repetitions !== null) {
                    data.structures[0].repetitions = Number(state.work.repetitions);
                }
                if (state.details.totalDistance) {
                    data.structures[0].planned_distance = state.details.totalDistance;
                }
                if (state.details.totalTime) {
                    data.structures[0].planned_time = state.details.totalTime;
                }

                _.each(state.work.pieces, (piece, pieceIndex) => {
                    data.structures[0].pieces[pieceIndex] = {};

                    if (piece.distance !== null) {
                        data.structures[0].pieces[pieceIndex].planned_distance = Number(piece.distance);
                    }

                    if (piece.time !== null) {
                        data.structures[0].pieces[pieceIndex].planned_time = piece.time;
                    }

                    data.structures[0].pieces[pieceIndex].split_length = piece.split_length;

                    if (piece.variable_split_lengths.length) {
                        data.structures[0].pieces[pieceIndex].type_of_split_length = 2;
                    } else {
                        data.structures[0].pieces[pieceIndex].type_of_split_length = 1;
                    }

                    if (piece.rest !== null) {
                        data.structures[0].pieces[pieceIndex].rest = piece.rest;
                    }

                    data.structures[0].pieces[pieceIndex].segments = [];

                    _.each(piece.variable_split_lengths, (length, key) => {
                        data.structures[0].pieces[pieceIndex].segments[key] = {
                            length: length
                        };
                    });
                });
            } else if (Number(state.details.sessionType) === LUDUM_SPORTS.SC) {
                // S&C
                _.each(state.work.scStructures, (structure, structIndex) => {
                    data.structures[structIndex] = {
                        sport: data.sport,
                        name: structure.name,
                        athletes: structure.athletes,
                        pieces: {}
                    };

                    if (state.work.repetitions !== null) {
                        data.structures[structIndex].repetitions = Number(state.work.repetitions);
                    }
                    if (state.details.totalDistance) {
                        data.structures[structIndex].planned_distance = state.details.totalDistance;
                    }
                    if (state.details.totalTime) {
                        data.structures[structIndex].planned_time = state.details.totalTime;
                    }

                    _.each(structure.exercises, (exercise, exerciseindex) => {
                        data.structures[structIndex].pieces[exerciseindex] = {
                            exercise_id: exercise.exercise_id,
                            sets_count: exercise.sets_count
                        };

                        if (exercise.reps_count && exercise.reps_count !== 'custom') {
                            data.structures[structIndex].pieces[exerciseindex].type_of_split_length = 1;
                            data.structures[structIndex].pieces[exerciseindex].reps_count = exercise.reps_count;
                        } else {
                            data.structures[structIndex].pieces[exerciseindex].type_of_split_length = 2;
                            data.structures[structIndex].pieces[exerciseindex].segments = {};

                            if (exercise.segments) {
                                for (let i = 0; i < exercise.sets_count; i++) {
                                    data.structures[structIndex].pieces[exerciseindex].segments[i] = {
                                        reps_count: exercise.segments[i]
                                    };
                                }
                            }
                        }
                    });
                });
            }

            return data;
        },

        newEventPreparedData(state, getters) {
            const data = getters.newSessionPreparedData;

            // We want these properties excluded when creating an event
            const excludedProperties = ['structures', 'sport', 'focuses', 'intensities', 'intensity_percentages'];

            return _.pickBy(data, (val, key) => {
                return !_.includes(excludedProperties, key);
            });
        }
    },

    mutations: {
        newSessionIntensities(state, data) {
            state.details.intensities = [];
            _.forEach(data, item => {
                state.details.intensities.push({
                    id: item.id,
                    name: item.name,
                    order: item.order,
                    selected: false,
                    percentage: 0,
                    color: item.color
                });
            });
        },
        clubExercises(state, data) {
            state.exercises = [...data];
        },
        removeUsers(state, userIds) {
            userIds.forEach(id => {
                delete state.attendance.coaches[id];
                delete state.attendance.athletes[id];
            });
        },
        setSession(state, data) {
            state = data;
        },
        updateSessionType(state, type) {
            state.details.sessionType = type;
        }
    },

    actions: {
        getExercises(context, payload) {
            return context.dispatch('get', {
                url: api + 'exercises',
                params: {
                    club_id: payload.club_id,
                    page: payload.page
                }
            });
        },
        createExercise(context, payload) {
            return context.dispatch('post', {
                url: api + 'exercises/add',
                data: payload
            });
        },
        createSession(context, payload) {
            return context.dispatch('post', {
                url: api + 'create-session',
                data: payload
            });
        },
        createEvent(context, payload) {
            return context.dispatch('post', {
                url: api + 'create-event',
                data: payload
            });
        },
        newSessionIntensities({ commit }, payload) {
            return commit('newSessionIntensities', payload);
        }
    }
};

export default createSession;
